import { Injectable } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { SessionStorage } from '@df/browser/storage/decorator/session-storage';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { Status } from '@df/core/status';
import { Nexus } from '@tomandco/nexus-api-types';

@Injectable({
    providedIn: 'root'
})
export class CheckoutService {
    @SessionStorage('lastStepName')
    lastStepName?: string;

    /**
     * Session storaged email address
     */
    @SessionStorage('checkoutEmail')
    checkoutEmail?: string;

    constructor(private request: RequestService) {}

    async load(status?: Status): Promise<Checkout.IData> {
        const result = await this.request.send(status, () => this.request.nexus.checkout.load());
        return result?.checkout;
    }

    loadSuccess(status?: Status): Promise<Nexus.Api.Checkout.Success.Response | Nexus.Lib.Response.Part.Checkout.RedirectResponse> {
        return this.request.send<Nexus.Api.Checkout.Success.Response | Nexus.Lib.Response.Part.Checkout.RedirectResponse>(status, () =>
            this.request.nexus.checkout.success({})
        );
    }

    reset(): void {
        this.lastStepName = undefined;
        this.checkoutEmail = undefined;
    }
}
